import React, { memo } from 'react';
import { Calendar, Users, Briefcase, Music, Camera, Award } from 'lucide-react';
import { AnimatedSection } from './AnimatedSection';
export function ServicesSection() {
  const services = [{
    title: 'Corporate Events',
    description: 'Conferences, product launches, team building, and corporate celebrations designed to align with your business objectives.',
    icon: <Briefcase className="h-8 w-8 text-indigo-500" data-id="element-205" />
  }, {
    title: 'Social Gatherings',
    description: 'Weddings, anniversaries, birthday celebrations, and reunions crafted to create joyful memories that last a lifetime.',
    icon: <Users className="h-8 w-8 text-indigo-500" data-id="element-206" />
  }, {
    title: 'Entertainment',
    description: 'Access to our network of performers, musicians, and entertainers to elevate your event experience.',
    icon: <Music className="h-8 w-8 text-indigo-500" data-id="element-207" />
  }, {
    title: 'Event Planning',
    description: 'Comprehensive planning services including venue selection, vendor coordination, and timeline management.',
    icon: <Calendar className="h-8 w-8 text-indigo-500" data-id="element-208" />
  }, {
    title: 'Photography & Video',
    description: 'Professional documentation of your event to capture every meaningful moment.',
    icon: <Camera className="h-8 w-8 text-indigo-500" data-id="element-209" />
  }, {
    title: 'Award Ceremonies',
    description: 'Elegant and prestigious award ceremonies that recognize achievements and motivate excellence.',
    icon: <Award className="h-8 w-8 text-indigo-500" data-id="element-210" />
  }];
  return <section id="services" className="py-16 bg-white" data-id="element-211">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-212">
        <AnimatedSection data-id="element-213">
          <div className="text-center" data-id="element-214">
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl" data-id="element-215">
              Our Services
            </h2>
            <p className="mt-4 max-w-2xl text-xl text-gray-600 mx-auto" data-id="element-216">
              We offer comprehensive event management solutions tailored to your
              specific needs.
            </p>
          </div>
        </AnimatedSection>
        <div className="mt-12 grid gap-8 grid-cols-1 md:grid-cols-2 lg:grid-cols-3" data-id="element-217">
          {services.map((service, index) => <AnimatedSection key={index} delay={index * 0.1} data-id="element-218">
              <div className="bg-gray-50 rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow duration-300 h-full" data-id="element-219">
                <div className="mb-4" data-id="element-220">{service.icon}</div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-221">
                  {service.title}
                </h3>
                <p className="text-gray-600" data-id="element-222">{service.description}</p>
              </div>
            </AnimatedSection>)}
        </div>
      </div>
    </section>;
}